import { render } from "./TransactionCompleteHeader.vue?vue&type=template&id=63a5a4c9&ts=true"
import script from "./TransactionCompleteHeader.vue?vue&type=script&lang=ts"
export * from "./TransactionCompleteHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__